import React, { Component } from 'react';
import { connect }          from 'react-redux';
import {Link}               from 'react-router-dom'

class topo_comunicacao extends Component {
    render() {
        return (
               <header className="hud-middle-center-header">
                    <div className="hud-quick-action hud-quick-action-left hud-quick-action-active" href={void(0)}>
                        <Link to={this.props.menu.comunicacao.tripulacao}>
                            Comunicação Tripulação
                        </Link>
                    </div>
                    <div className="hud-title">
                       {this.props.nome}
                    </div>
                    <div className="hud-quick-action hud-quick-action-right hud-quick-action-active" href={void(0)}>
                        <Link to={this.props.menu.comunicacao.equipes}>
                            Comunicação Equipe
                        </Link>
                    </div>
                </header>
        );
    }
}

function mapStateToProps(state){  
    return { menu : state.configReducer.menu};
}

export default connect(mapStateToProps)(topo_comunicacao);




// WEBPACK FOOTER //
// ./src/components/aluno/comunicacao/topo_comunicacao.js